'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import H3 from 'UIComponents/elements/headings/H3';
import UIFlex from 'UIComponents/layout/UIFlex';

const InnerSectionHeading = ({
  children,
  className,
  itemRight
}) => {
  if (itemRight) {
    return /*#__PURE__*/_jsxs(UIFlex, {
      className: className,
      justify: "between",
      align: "center",
      wrap: "wrap",
      children: [/*#__PURE__*/_jsx(H3, {
        className: "m-bottom-0",
        children: children
      }), itemRight]
    });
  }

  return /*#__PURE__*/_jsx(H3, {
    className: className,
    children: children
  });
};

InnerSectionHeading.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  itemRight: PropTypes.node
};
InnerSectionHeading.defaultProps = {
  className: 'm-bottom-4'
};
export default InnerSectionHeading;